const baseURL = "/v1/CalendarioFormacao";

const service = {
  methods: {
    $buscarCalendarioPaginaInicial() {
      return this.$api().get(baseURL);
    },
    $detalharCalendarioPaginaInicial(mes, ano, params) {
      return this.$api().get(`${baseURL}/Detalhar/${mes}/${ano}`, { params });
    },
    $downloadArquivosCalendarioPaginaInicial(mes, ano, params) {
      return this.$api().get(`${baseURL}/Baixar/${mes}/${ano}`, this.$getParamsObject(params));
    },
  },
};

export default service;
